import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect } from 'react';
import { useProgress } from '../../common/utils/use-progress';
export var FAILED_SITE_KEY_RETRIEVAL = Object.freeze({
  failed: true,
  siteKey: undefined
});
/**
 * TODO: Could probably just use the Commerce service hook
 */

export var useSiteKeyService = function useSiteKeyService(fetchServerSideSiteKey) {
  var _useProgress = useProgress(),
      _useProgress2 = _slicedToArray(_useProgress, 3),
      progress = _useProgress2[0],
      setLoaded = _useProgress2[1],
      setLoading = _useProgress2[2];

  useEffect(function () {
    setLoading();
    var stillMounted = true;

    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var siteKeyPayload;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetchServerSideSiteKey();

            case 3:
              siteKeyPayload = _context.sent;

              if (stillMounted) {
                setLoaded(siteKeyPayload);
              }

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);

              if (stillMounted) {
                setLoaded(FAILED_SITE_KEY_RETRIEVAL);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();

    return function () {
      stillMounted = false;
    };
  }, [fetchServerSideSiteKey, setLoading, setLoaded]); // TODO: Allow for retrying

  return progress;
};
export var shouldSkipReCaptchaChallenge = function shouldSkipReCaptchaChallenge(siteKey) {
  return siteKey === null;
};